import React from 'react';
import { API_URL } from '../../constants/api';
import { apiBatchRequest, apiPost, apiPut, apiRequest, getSpsAPiRequest, spsApiPost } from '../../utils/api_service';
import { ShowToast, toastType } from '../../utils/toast-service';
import PageHeader from '../common/PageHeader';
import {
  ExpenseColumns,
  PedingActionColumns,
  PendingMarketAllocation,
  PendingPropertyAllocation,
  propertyColumnsPTF,
  readOnlyClientContactDetailsColumn,
  readOnlyManagementFeeColumns,
  EngineerHourBillingColumns
} from '../../constants/MockData';
import GridTable from '../common/Table/Table';
import {
  AppBar,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  Paper,
  TextareaAutosize,
  Toolbar,
  Tooltip,
  Typography
} from '@material-ui/core';
import { Visibility } from '@material-ui/icons';
import FormGenerator from '../common/FormGenerator';
import '../PendingRequest/index.less';
import CloseIcon from '@material-ui/icons/Close';
import _ from 'lodash';
import {
  applyFilterOnData,
  getSectionAttributesByKeyValue,
  getSectionAttributeValueByKey,
  removeDuplicates,
  RemoveSectionAttributeByKeyValue,
  setAllSectionAttributeValueByKey,
  setSectionFieldAttributeByKey,
  UpdateColumnWithConfiguration,
  UpdateFieldsWithConfiguration,
  useQuery,
  IsSectionVisible,
  cloneDeep,
  setSectionAttributeValueByKey
} from '../../utils/helper';
import moment from 'moment';
import commonLabels from '../../constants/messageConstants';
import { NavLink } from 'react-router-dom';
import { getSPSTokenData, Operators, setSPSToken, SECTIONS } from '../../constants/appConstants';
import { getSharePointUrl } from '../../constants/sharepointApi';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import { controlType } from '../../constants/common';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import PageFilter from '../common/PageFilter';
import { convertToLocalDate } from '../../utils/date';

// Handle pending requests like PTF, Allocations etc. User can Approve or Suggest changes for the requests.
class PendingRequests extends React.PureComponent {
  // Constructor to define intitial state
  constructor(props) {
    super(props);
    this.state = {
      pendingActionsData: [],
      configuration: [],
      openDialog: false,
      pendingActionsDetails: [],
      pendingActionsDetailsConfig: [],
      openComment: false,
      selectedCategory: undefined,
      selectedRequestRow: undefined,
      showMain: false,
      viewFile: false,
      addNewformComponent: undefined,
      filesToBeUploaded: [],
      selectedData: [],
      isSaveButtonDisabled: false,
      uniquCategoryData: [],
      responsePendingActionsData: [],
      uniqueDescriptionData: [],
      redirectedFromNotification: false,
      selectedRow: undefined,
      selectedAllocation: [],
      serviceTypeMasterData: [],
      propertyTypeMasterData: [],
      propertyDetailsData: [],
      headerData: {
        selectAll: false
      },
      propertyMasterData: []
    };
  }

  // Method is used to setup UI for the request based on request type.
  componentDidUpdate(previousProps, previousState) {
    if ((((previousProps || {}).location || {}).navProps || {}).selectedRow !== (((this.props || {}).location || {}).navProps || {}).selectedRow) {
      this.setupPendingRequestUI((this.props || {}).location);
    }
  }

  // Method is used to compare state changes
  static getDerivedStateFromProps(newProps, state) {
    if ((((newProps || {}).location || {}).navProps || {}).selectedRow !== (state || {}).selectedRow) {
      return {
        selectedRow: ((((newProps || {}).location || {}).navProps || {}).selectedRow)
      };
    }
    return null;
  }

  // Setup User Interface to load pending request details
  setupPendingRequestUI = (location) => {
    if (((location || {}).navProps || {}).selectedRow) {
      if (location.navProps.selectedRow.parentRecordId !== undefined) {
        this.setState({ redirectedFromNotification: true });
        const selectedRow = location.navProps.selectedRow;
        const row = this.getRequestDetails(selectedRow.parentRecordId, selectedRow.module, selectedRow.header);
        row.modifiedBy = selectedRow.createdBy;
        row.modifiedOn = convertToLocalDate(selectedRow.createdDate, 'MM-DD-YYYY hh:mm A');
        this.showDetails(row);
      } else {
        this.setState({ redirectedFromNotification: false });
        this.showDetails(
          ((location || {}).navProps || {}).selectedRow
        );
      }
    } else {
      // Read querystring values to load request details
      const query = useQuery();
      const parentRecordId = query.get('parentRecordId');
      const module = query.get('module');
      const feature = query.get('feature');
      const recordId = query.get('recordId');
      const category = query.get('category');
      const recordIdType = query.get('recordIdType');
      const modifiedBy = query.get('modifiedBy');
      let modifiedOn = query.get('modifiedOn');
      if (modifiedOn !== null || modifiedOn !== '') {
        modifiedOn = convertToLocalDate(modifiedOn, 'MM-DD-YYYY hh:mm A');
      }
      if (parentRecordId !== undefined && parentRecordId !== null) {
        this.setState({ redirectedFromNotification: true });
        const row = this.getRequestDetails(parentRecordId, module, feature);
        this.showDetails(row);
      } else if (recordId !== undefined && recordId !== null) {
        this.setState({ redirectedFromNotification: false });
        const row = { recordId: recordId, category: category, recordIdType: recordIdType, modifiedBy, modifiedOn };
        this.showDetails(row);
      }
    }
  }

  // Method is used to load master data and request data to show on UI
  componentDidMount() {
    this.LoadData();
    this.setupPendingRequestUI(this.props.location);
  }

  // Get Master and Request Data from Database
  LoadData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Dashboard.GetPendingActions,
        key: 'pendingActionsData'
      },
      {
        url: API_URL.Assignments.GetServiceTypeMasterData + '?outputType=ListAll',
        key: 'serviceTypeMasterData',
        fromCache: true,
        duration: 60
      },
      {
        url: API_URL.Property.GetPropertyTypeMasterData,
        key: 'propertyTypeMasterData'
      },
      {
        url:
          API_URL.Employee.GetEmployeeMasterData +
          '?showInActive=true&outputType=ListAll',
        key: 'employeesAllMasterData',
        fromCache: true,
        duration: 15
      },
      {
        url: API_URL.Property.GetPropertyMasterData,
        key: 'propertyMasterData',
      },
    ])
      .then(({ pendingActionsData, serviceTypeMasterData, propertyTypeMasterData, employeesAllMasterData, propertyMasterData }) => {
        this._asyncRequest = null;
        if (pendingActionsData.success === true) {
          pendingActionsData?.data?.forEach(x => {
            x.modifiedOn = convertToLocalDate(x.modifiedOn, 'MM-DD-YYYY hh:mm A');
          });
          const uniquCategoryData = removeDuplicates(pendingActionsData.data, 'category');
          const uniqueDescriptionData = removeDuplicates(pendingActionsData.data, 'categoryDescription');
          this.setState({
            pendingActionsData: applyFilterOnData(_.cloneDeep([...pendingActionsData.data || []]), this.state.selectedData),
            configuration: pendingActionsData.config || [],
            uniquCategoryData,
            responsePendingActionsData: _.cloneDeep(pendingActionsData.data || []),
            uniqueDescriptionData,
            serviceTypeMasterData: serviceTypeMasterData.data || [],
            propertyTypeMasterData: propertyTypeMasterData.data || [],
            employeesAllMasterData: employeesAllMasterData.data || [],
            propertyMasterData: propertyMasterData.data || []
          });
        } else {
          ShowToast(
            commonLabels.somethingWrong,
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        }
      })
      .catch(() => {
        this._asyncRequest = null;
        ShowToast(
          commonLabels.somethingWrong,
          toastType.ERROR,
          5000,
          500,
          'Server error'
        );
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  // Get request details and categorize the type, module and category of the selected request
  getRequestDetails = (id, module, feature) => {
    let category = '';
    let recordIdType = 'PropertyId';
    if (module.includes('PTF')) {
      category = 'PTF';
    } else if (module.includes('Assignments')) {
      category = 'Assignment';
    } else if (module.includes('Allocations')) {
      category = feature.includes('Market') ? 'Market Allocation' : 'Property Allocation';
      recordIdType = feature.includes('Market') ? 'MarketId' : 'PropertyId';
    }
    return { recordId: id, category: category, recordIdType: recordIdType };
  }

  // Show details of selected request
  showDetails = (row) => {
    let id = row.recordId;
    let category = row.category;
    if (category === undefined) {
      if (row.header.includes('Assignment')) {
        category = 'Assignment';
        id = row.parentRecordId;
      } else if (row.header.includes('Transition')) {
        id = row.parentRecordId;
        category = 'PTF';
      } else if (row.header.includes('Property')) {
        id = row.parentRecordId;
        category = 'Property Allocation';
      } else if (row.header.includes('Market')) {
        id = row.parentRecordId;
        category = 'Market Allocation';
      }
    }

    const URLConfig = [
      {
        category: 'Assignment',
        Url: API_URL.Assignments.GetAssignmentDetails,
        sourceField: 'assignmentId'
      },
      {
        category: 'Market Allocation',
        Url: API_URL.Allocation.GetAllocationData,
        sourceField: row.recordIdType,
        extraPram: '&allocationType=Market'
      },
      {
        category: 'Property Allocation',
        Url: API_URL.Allocation.GetAllocationData,
        sourceField: row.recordIdType,
        extraPram: '&allocationType=Property'
      },
      {
        category: 'PTF',
        Url: API_URL.Transition.GetTransitionDetails,
        sourceField: 'transitionId'
      }
    ];

    const selectedURL = URLConfig.find((x) => x.category === category);
    this._asyncRequest = apiBatchRequest([
      {
        url:
          selectedURL.Url +
          '?' +
          selectedURL.sourceField +
          '=' +
          id +
          (selectedURL.extraPram || ''),
        key: 'pendingActionsDetails'
      }
    ])
      .then(({ pendingActionsDetails }) => {
        this._asyncRequest = null;
        if (pendingActionsDetails.success === true) {
          if (pendingActionsDetails.data === null) {
            ShowToast('Data Not Found', toastType.ERROR, 5000, 500);
            this.setState({
              openDialog: false,
              pendingActionsDetails: [],
              pendingActionsDetailsConfig: [],
              openComment: false,
              selectedCategory: undefined,
              selectedRequestRow: undefined,
              redirectedFromNotification: false
            });
            return false;
          }
          if (category === 'PTF') {
            const transitionType = getSectionAttributeValueByKey(pendingActionsDetails.data, 'TransitionTypeId');
            const serviceTypes = getSectionAttributeValueByKey(pendingActionsDetails.data, 'ServiceType');
            const selectedPropertyId = transitionType?.toString() === '2'
              ? getSectionAttributeValueByKey(pendingActionsDetails.data, 'CiOProperties')
              : getSectionAttributeValueByKey(pendingActionsDetails.data, 'PropertyId');
            const approvalStatusId = getSectionAttributeValueByKey(pendingActionsDetails.data, 'ApprovalStatusId');
            const propertyTransitionId = getSectionAttributeValueByKey(pendingActionsDetails.data, 'PropertyTransitionId');
            const isImpakSetup = getSectionAttributeValueByKey(pendingActionsDetails.data, 'IMPAKSetup');
            setSectionFieldAttributeByKey(pendingActionsDetails.data || [], 'EmailCC', 'isEditable', false);
            setSectionFieldAttributeByKey(pendingActionsDetails.data || [], 'LegalEntitySF', 'isEditable', false);
            if (isImpakSetup === null || isImpakSetup === '' || isImpakSetup === 'No' || isImpakSetup === '0') {
              setSectionFieldAttributeByKey(pendingActionsDetails.data || [], 'IMPAKSetupDate', 'isVisible', false);
            }
            if (transitionType?.toString() === '3' && serviceTypes.split('|').includes('Property Accounting')) {
              setSectionFieldAttributeByKey(pendingActionsDetails.data || [], 'ExtendedDate', 'isVisible', true);
            } else {
              setSectionFieldAttributeByKey(pendingActionsDetails.data || [], 'ExtendedDate', 'isVisible', false);
            }
            if ((this.state.redirectedFromNotification && propertyTransitionId !== id) || approvalStatusId !== '3') {
              ShowToast('This request is not currently applicable for Approval process. It has been either Approved or Suggested for Changes.', toastType.INFO, 5000, 500);
              this.setState({
                pendingActionsDetails: pendingActionsDetails.data || [],
                pendingActionsDetailsConfig: pendingActionsDetails.config || [],
                selectedCategory: category,
                selectedRequestRow: row,
                openDialog: false,
                allocationData: allocationData.data || [],
                redirectedFromNotification: false
              });
              return;
            }
            if (
              (getSectionAttributeValueByKey(
                pendingActionsDetails.data || [],
                'transitionTypeId',
                false
              ) || '1') === '3'
            ) {
              setSectionFieldAttributeByKey(pendingActionsDetails.data || [], 'TerminationDocumentName', 'isVisible', true);
              setSectionFieldAttributeByKey(pendingActionsDetails.data || [], 'TerminationDocumentName', 'isRequired', 1);
              setSectionFieldAttributeByKey(pendingActionsDetails.data || [], 'TerminationDocumentName', 'isEditable', 1);
              setSectionFieldAttributeByKey(pendingActionsDetails.data || [], 'TerminationDocumentName', 'isEditable', 1);
              setSectionFieldAttributeByKey(pendingActionsDetails.data || [], 'TerminationDocumentName', 'attributeSortOrder', 3);
            }

            apiBatchRequest([{
              url:
                API_URL.Allocation.GetAllocationData +
                '?propertyId=' +
                ((selectedPropertyId || '') === ''
                  ? -1
                  : selectedPropertyId),
              key: 'allocationData'
            },
            {
              url: API_URL.Property.GetPropertyData +
                '?transitionId=' + propertyTransitionId,
              key: 'PropertyData'
            }]).then(
              ({
                allocationData, PropertyData
              }) => {
                const serviceType = (getSectionAttributeValueByKey(pendingActionsDetails.data || [], 'ServiceType') || '').split('|');
                (allocationData || {}).data = (allocationData.data || []).filter(x => serviceType.find(y => y === x.serviceType) ||
                  (x.serviceType || '').split('|').find(z => serviceType.find(yy => yy === z)));
                this.setState({
                  pendingActionsDetails: pendingActionsDetails.data || [],
                  pendingActionsDetailsConfig: pendingActionsDetails.config || [],
                  selectedCategory: category,
                  selectedRequestRow: row,
                  openDialog: true,
                  allocationData: allocationData.data || [],
                  propertyData: PropertyData.data || [],
                  redirectedFromNotification: false
                }, () => {
                  this.getSpsData();
                });
              });
          } else {
            let isRecordExists = false;
            if (category.includes('Property Allocation')) {
              (pendingActionsDetails.data || []).forEach(x => {
                if (x.isSwapAllocation === 1 && x.parentSwapAllocationId > 0 && x.parentSwapAllocationId !== x.allocationId) {
                  const employeeName = pendingActionsDetails.data?.find(z => z.allocationId === x.parentSwapAllocationId)?.preferredName || '';
                  x.tooltip = 'This is the record created for swapping of Employee ' + employeeName + ' with ' + x.preferredName + ' for Property ' + x.propertyName + '';
                }
              });
            }
            if (this.state.redirectedFromNotification) {
              if (category.includes('Market Allocation')) {
                let cnt = 0;
                cnt = (pendingActionsDetails.data || []).filter((x) => (x.marketId || '').toString() === id && x.approvalId === 3).length;
                const cntObj = (pendingActionsDetails.data || []).filter((x) => (x.marketId || '').toString() === id && x.approvalId === 3);
                isRecordExists = cnt > 0;
                if (isRecordExists) {
                  row.modifiedBy = cntObj[0].lastModifiedBy;
                  row.modifiedOn = convertToLocalDate(cntObj[0].lastModifiedOn, 'MM-DD-YYYY hh:mm A');
                }
              } else if (category.includes('Property Allocation')) {
                let cnt = 0;
                cnt = (pendingActionsDetails.data || []).filter((x) => (x.marketId || '').toString() === id && x.approvalId === 3).length;
                const cntObj = (pendingActionsDetails.data || []).filter((x) => (x.marketId || '').toString() === id && x.approvalId === 3);
                isRecordExists = cnt > 0;
                if (isRecordExists) {
                  row.modifiedBy = cntObj[0].lastModifiedBy;
                  row.modifiedOn = convertToLocalDate(cntObj[0].lastModifiedOn, 'MM-DD-YYYY hh:mm A');
                }
              } else if (category.includes('Assignment')) {
                const approvalStatusId = getSectionAttributeValueByKey(pendingActionsDetails.data, 'approvalStatusId');
                const assignmentId = getSectionAttributeValueByKey(pendingActionsDetails.data, 'assignmentId');
                isRecordExists = !!((approvalStatusId === '3' && assignmentId === id));
              }
            }
            if (this.state.redirectedFromNotification && (!isRecordExists)) {
              ShowToast('This request is not currently applicable for Approval process. It has been either Approved or Suggested for Changes.', toastType.INFO, 5000, 500);
              this.setState({
                pendingActionsDetails: pendingActionsDetails.data || [],
                pendingActionsDetailsConfig: pendingActionsDetails.config || [],
                selectedCategory: category,
                selectedRequestRow: row,
                openDialog: false,
                redirectedFromNotification: false
              });
            } else {
              this.setState({
                pendingActionsDetails: pendingActionsDetails.data || [],
                pendingActionsDetailsConfig: pendingActionsDetails.config || [],
                selectedCategory: category,
                selectedRequestRow: row,
                openDialog: true,
                redirectedFromNotification: false
              }, () => {
                if (category === 'Assignment') {
                  this.getSpsData();
                }
              });
            }
          }
        } else {
          ShowToast(
            commonLabels.somethingWrong,
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        }
      })
      .catch(() => {
        this._asyncRequest = null;
        ShowToast(
          commonLabels.somethingWrong,
          toastType.ERROR,
          5000,
          500,
          'Server error'
        );
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  // Render Action column for earch record in the table
  renderActionColumn = (row) => {
    return (
      <>
        <Tooltip title="View">
          <IconButton
            aria-label={'refreshData'}
            size="small"
            onClick={() => {
              this.setState({ redirectedFromNotification: false });
              this.showDetails(row);
            }}
          >
            <Visibility fontSize="small" size="small" />
          </IconButton>
        </Tooltip>
      </>
    );
  };

  // Filters the records from table based on selected filter values
  onFilterChange = (selectedData) => {
    const { responsePendingActionsData } = this.state;
    const filteredData = applyFilterOnData(_.cloneDeep([...responsePendingActionsData]), selectedData);
    this.setState({ pendingActionsData: filteredData, selectedData });
  };

  // Approve selected request
  approveRequest = () => {
    const { approve, reviewComment } = this.state;
    this.setState({ isSaveButtonDisabled: true });
    if (
      approve &&
      (reviewComment === undefined || (reviewComment || '').trim().length === 0)
    ) {
      ShowToast('Please enter valid comments', toastType.ERROR, 5000, 5000);
      this.setState({ isSaveButtonDisabled: false });
      return;
    }

    if (
      !approve &&
      (reviewComment === undefined || (reviewComment || '').trim().length === 0)
    ) {
      ShowToast('Please enter valid comments', toastType.ERROR, 5000, 5000);
      this.setState({ isSaveButtonDisabled: false });
      return;
    }
    const URLConfig = [
      {
        category: 'Assignment',
        Url: API_URL.Assignments.UpdateAssignment,
        sourceField: 'assignmentId'
      },
      {
        category: 'Market Allocation',
        Url: API_URL.Allocation.UpdateMultipleAllocation,
        sourceField: 'AllocationId'
      },
      {
        category: 'Property Allocation',
        Url: API_URL.Allocation.UpdateMultipleAllocation,
        sourceField: 'AllocationId'
      },
      {
        category: 'PTF',
        Url: API_URL.Transition.UpdateTransition,
        sourceField: 'transitionId'
      }
    ];

    let detailsToUpdate = this.state.pendingActionsDetails;
    const selectedRequestRow = this.state.selectedRequestRow;
    const selectedAllocation = this.state.selectedAllocation;
    let message = '';
    if (selectedRequestRow.category === 'Assignment') {
      setAllSectionAttributeValueByKey(
        detailsToUpdate,
        'ReviewComment',
        reviewComment
      );
      setAllSectionAttributeValueByKey(
        detailsToUpdate,
        'ApprovalStatusId',
        approve ? '4' : '9'
      );
      setAllSectionAttributeValueByKey(
        detailsToUpdate,
        'ApprovalStatus',
        approve ? 'Approved' : 'Requested changes'
      );
      message = 'The record will appear on \'Assignment Tab\'.';
    } else if (
      selectedRequestRow.category === 'Market Allocation' ||
      selectedRequestRow.category === 'Property Allocation'
    ) {
      if (selectedAllocation === undefined || selectedAllocation.length <= 0) {
        ShowToast(
          'Please select at least one pending ' + selectedRequestRow.category + '.',
          toastType.ERROR,
          5000,
          commonLabels.somethingWrong.code
        );
        this.setState({ isSaveButtonDisabled: false });
        return;
      }
      detailsToUpdate = [];
      detailsToUpdate = selectedAllocation.filter(
        (x) => x.approvalStatus === 'Pending Approval'
      );
      detailsToUpdate.map((value) => {
        if (value.approvalStatus === 'Pending Approval') {
          value.approvalStatus = approve ? 'Approved' : 'Requested changes';
          value.approvalId = approve ? 4 : 9;
          value.isApproved = approve;
          value.approvalStatusId = approve ? 4 : 9;
          value.isApproved = approve;
          value.statusId = 1;
          value.reviewComment = reviewComment;
          value.recordSource = selectedRequestRow.category === 'Property Allocation' ? 8 : 0;
        }
        Object.keys(value).forEach((x) => {
          if (value[x] === '0001-01-01T00:00:00') {
            value[x] = undefined;
          }
        });
      });
      if (selectedRequestRow.category === 'Market Allocation') {
        message = 'The record will appear on \'Allocations Tab\'.';
      } else {
        message = 'The record will appear on \'Allocations Tab\'.';
      }
    } else if (selectedRequestRow.category === 'PTF') {
      if (detailsToUpdate.find((x) => x.dbColumn === 'Notify') === undefined) {
        detailsToUpdate.push({
          attributeSortOrder: 2,
          attributeValue: false,
          dataFormat: 'Boolean',
          dbColumn: 'notify',
          displayName: 'Notify',
          isEditable: false,
          isRequired: false,
          isVisible: false,
          recordId: null,
          sectionDetailId: 274,
          sectionId: 26
        });
      }

      if (detailsToUpdate.find((x) => x.dbColumn === 'files') === undefined) {
        detailsToUpdate.push({
          attributeSortOrder: 2,
          attributeValue: this.state.files,
          dataFormat: 'Text',
          dbColumn: 'files',
          displayName: 'files',
          isEditable: false,
          isRequired: false,
          isVisible: false,
          recordId: null,
          sectionDetailId: 274,
          sectionId: 26
        });
      }
      setSectionFieldAttributeByKey(
        detailsToUpdate,
        'Notify',
        'attributeValue',
        approve ? 'notify' : 'notify'
      );
      setAllSectionAttributeValueByKey(
        detailsToUpdate,
        'ReviewComment',
        reviewComment
      );
      setAllSectionAttributeValueByKey(
        detailsToUpdate,
        'ApprovalStatusId',
        approve ? '4' : '9'
      );
      message = 'The record will appear on \'Property Transitions Tab\'.';
    }
    const selectedURL = URLConfig.find(
      (x) => x.category === selectedRequestRow.category
    );

    if (
      selectedRequestRow.category !== 'Market Allocation' &&
      selectedRequestRow.category !== 'Property Allocation'
    ) {
      apiPut(
        selectedURL.Url +
        '?' +
        selectedURL.sourceField +
        '=' +
        selectedRequestRow.recordId,
        detailsToUpdate
      ).then(({ data: response }) => {
        if (response.success === true) {
          this.setState(
            {
              openDialog: false,
              pendingActionsDetails: [],
              pendingActionsDetailsConfig: [],
              openComment: false,
              approve: undefined,
              reviewComment: '',
              selectedCategory: undefined,
              selectedRequestRow: undefined,
              isSaveButtonDisabled: false,
              selectedAllocation: [],
              headerData: {
                selectAll: false
              }
            },
            this.LoadData()
          );
          ShowToast(
            'Record updated successfully. ' + message,
            toastType.SUCCESS,
            5000,
            500
          );
        }
      });
    } else {
      apiPost({
        url:
          selectedURL.Url +
          '?' +
          selectedURL.sourceField +
          '=' +
          selectedRequestRow[selectedURL.sourceField],
        postBody: detailsToUpdate
      }).then(({ success: isExecuted }) => {
        if (isExecuted === true) {
          this.setState(
            {
              openDialog: false,
              pendingActionsDetails: [],
              pendingActionsDetailsConfig: [],
              openComment: false,
              approve: undefined,
              reviewComment: '',
              selectedCategory: undefined,
              selectedRequestRow: undefined,
              isSaveButtonDisabled: false,
              selectedAllocation: [],
              headerData: {
                selectAll: false
              }
            },
            this.LoadData()
          );
          ShowToast(
            'Record updated successfully.' + message,
            toastType.SUCCESS,
            5000,
            500
          );
        } else {
          ShowToast(
            commonLabels.somethingWrong.message,
            toastType.ERROR,
            5000,
            commonLabels.somethingWrong.code
          );
        }
      });
    }
  };

  // Go to the main page
  goBack = () => {
    this.setState({
      showMain: true
    });
  };

  // Get clean name by replacing special chatacters, spaces etc.
  cleanName = (name) => {
    // console.log(name);
    if (name === undefined) {
      return;
    }
    name = name.replace(/\s+/gi, '-'); // Replace white space with dash
    return name.replace(/[^a-zA-Z0-9]/gi, ''); // Strip any special charactere
  };

  // Set data based on the categories
  setCategoryWiseData = (spsDataRes) => {
    if (!spsDataRes) return;
    const transitionData = this.state.pendingActionsDetails;
    const { value } = _.cloneDeep(spsDataRes);
    const spsCategories = {
      ChangeInOwnerShip: [],
      NewAssignment: [],
      Termination: [],
      OtherDocs: [],
      "W-9": []
    };
    const categoriesKeysList = Object.keys(spsCategories);
    value && value.forEach(obj => {
      const catKeyByName =
        categoriesKeysList.indexOf(obj.name.split('_')[0]) !== -1
          ? obj.name.split('_')[0]
          : '';
      const caseKey =
        (obj.listItem.fields.FileType || '') || catKeyByName;
      switch (caseKey) {
        case 'NewAssignment':
          spsCategories[caseKey].push(obj);
          break;
        case 'ChangeInOwnerShip':
          spsCategories[caseKey].push(obj);
          break;
        case 'Termination':
          spsCategories[caseKey].push(obj);
          break;
        case 'W-9':
          spsCategories['NewAssignment'].push(obj);
          break;
        default:
          spsCategories.OtherDocs.push(obj);
          break;
      }
    });

    const terminationDocumentname = getSectionAttributeValueByKey(
      transitionData,
      'TerminationDocumentName'
    );
    let terminationDocumentnameArray = terminationDocumentname.split('|') || [];
    let terminationDocumentsArray = spsCategories.Termination || [];
    terminationDocumentsArray = terminationDocumentsArray.filter(x => terminationDocumentnameArray.includes(x.name)) || [];
    terminationDocumentnameArray = terminationDocumentnameArray.filter(x => terminationDocumentsArray.find(y => y.name === x)) || [];
    setSectionAttributeValueByKey(
      transitionData,
      'TerminationDocumentName',
      terminationDocumentnameArray.join('|') || ''
    );
    spsCategories.Termination = terminationDocumentsArray;

    // 1. Get the referenced file names from both fields (preserve original values)
    const dbW9DocumentNames = (getSectionAttributeValueByKey(transitionData, 'W9DocumentName') || '').split('|').filter(Boolean);
    const dbAssignmentDocumentNames = (getSectionAttributeValueByKey(transitionData, 'DocumentName') || '').split('|').filter(Boolean);

    // 2. Combine both lists for easy lookup
    let newAssignmentDocumentsNameArray = [...dbW9DocumentNames, ...dbAssignmentDocumentNames];
        
    let newAssignmentDocumentsArray = spsCategories.NewAssignment;
    // 3. Filter SharePoint files to only those referenced in either field
    const matchedNewAssignmentDocs = newAssignmentDocumentsArray.filter(x => {
      return newAssignmentDocumentsNameArray.includes(x.name);
    });

    // Only update document names if we found files in SharePoint
    if (matchedNewAssignmentDocs.length > 0) {
      // Filter DB names to only those found in SharePoint
      newAssignmentDocumentsNameArray = newAssignmentDocumentsNameArray.filter(x => {
        return matchedNewAssignmentDocs.find(y => y.name === x)
      }) || [];

      const foundW9Names = dbW9DocumentNames.filter(x => matchedNewAssignmentDocs.find(y => y.name === x));
      const foundAssignmentNames = dbAssignmentDocumentNames.filter(x => matchedNewAssignmentDocs.find(y => y.name === x)); 

      setSectionAttributeValueByKey(
        transitionData,
        'DocumentName',
        foundAssignmentNames.join('|') || ''
      );

      setSectionAttributeValueByKey(
        transitionData,
        'W9DocumentName',
        foundW9Names.join('|') || ''
      );
      
      newAssignmentDocumentsArray = matchedNewAssignmentDocs;
    } else {
      // No files found in SharePoint - KEEP EXISTING DB VALUES
      console.warn('No files found in SharePoint folder. Keeping existing document names from database.');
      
      setSectionAttributeValueByKey(
        transitionData,
        'DocumentName',
        dbAssignmentDocumentNames.join('|') || ''
      );

      setSectionAttributeValueByKey(
        transitionData,
        'W9DocumentName',
        dbW9DocumentNames.join('|') || ''
      );
      
      // Set empty array since no files were found
      newAssignmentDocumentsArray = [];
      newAssignmentDocumentsNameArray = [];
    }
    spsCategories.NewAssignment = newAssignmentDocumentsArray;

    const changeInOwnerShipDocumentname = getSectionAttributeValueByKey(
      transitionData,
      'ChangeOfOwnershipDocumentName'
    );
    let changeInOwnerShipDocumentnameArray = changeInOwnerShipDocumentname.split('|') || [];
    let changeInOwnerShipDocumentsArray = spsCategories.ChangeInOwnerShip || [];
    changeInOwnerShipDocumentsArray = changeInOwnerShipDocumentsArray.filter(x => changeInOwnerShipDocumentnameArray.includes(x.name)) || [];
    changeInOwnerShipDocumentnameArray = changeInOwnerShipDocumentnameArray.filter(x => changeInOwnerShipDocumentsArray.find(y => y.name === x)) || [];
    setSectionAttributeValueByKey(
      transitionData,
      'ChangeOfOwnershipDocumentName',
      changeInOwnerShipDocumentnameArray.join('|') || ''
    );
    spsCategories.ChangeInOwnerShip = changeInOwnerShipDocumentsArray;

    let files = '';
    const newAssignmentFiles = newAssignmentDocumentsArray;
    if (newAssignmentFiles && newAssignmentFiles.length > 0) {
      newAssignmentFiles.forEach((x) => {
        x['@microsoft.graph.downloadUrl'] && (files += (x.name + '$$$' + x['@microsoft.graph.downloadUrl'] + '%%%'));
      });
    }

    const terminationAssignmentFiles = terminationDocumentsArray;
    if (terminationAssignmentFiles && terminationAssignmentFiles.length > 0) {
      terminationAssignmentFiles.forEach((x) => {
        x['@microsoft.graph.downloadUrl'] && (files += (x.name + '$$$' + x['@microsoft.graph.downloadUrl'] + '%%%'));
      });
    }

    const cioAssignmentFiles = changeInOwnerShipDocumentsArray;
    if (cioAssignmentFiles && cioAssignmentFiles.length > 0) {
      cioAssignmentFiles.forEach((x) => {
        x['@microsoft.graph.downloadUrl'] && (files += (x.name + '$$$' + x['@microsoft.graph.downloadUrl'] + '%%%'));
      });
    }

    this.setState({ spsData: spsCategories, spsAllData: spsDataRes, reloadPtf: !this.state.reloadPtf, files: files });
  }

  // Get PTF documents from sharepoint
  getSpsData = () => {
    if (getSPSTokenData()) {
      this.setState({ spsData: {} });
      const assignmentName = getSectionAttributeValueByKey(this.state.pendingActionsDetails, 'assignmentName', false);
      const folderName = getSectionAttributeValueByKey(this.state.pendingActionsDetails, 'folderName', false) ?? this.cleanName(assignmentName);

      getSpsAPiRequest(getSharePointUrl('streamrealty', 'getFolder', '', folderName)).then((res) => {
        if (res !== null && (res.displayName === folderName || res.name === folderName)) {
          const folder = res;
          const driveId = folder.parentReference.driveId;
          const key = folder.id;
          this.setState({ folderName: folderName, spListkey: key });
          if (this.state.filesToBeUploaded && this.state.filesToBeUploaded.length > 0) {
            this.uploadFilesToSharePoint();
          }
          getSpsAPiRequest(getSharePointUrl('streamrealty', 'getChildItem', key, '', driveId)).then((files) => {
            this.setCategoryWiseData(files);
          });
        } else {
          if (folderName.length > 0) {
            spsApiPost({
              url: getSharePointUrl('streamrealty', 'createFolder'),
              postBody: {
                displayName: folderName,
                columns: [
                  {
                    name: 'FileType',
                    text: {}
                  },
                  {
                    name: 'UserEmail',
                    text: {}
                  },
                  {
                    name: 'UserEmail',
                    text: {}
                  }
                ],
                list: {
                  template: 'documentLibrary'
                }
              }
            }).then((data) => {
              if (data) {
                this.getSpsData();
              }
            });
          }
        }
      });
    } else {
      apiRequest({ url: API_URL.Users.AcquireSPToken }).then(({ updateData }) => {
        if (updateData) {
          setSPSToken(updateData);
          this.getSpsData();
        }
      });
    }
  }

  // Convert data to blob
  b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  // Show selected file in file viewer (iFrame)
  showFile = (url, title, isSpsFile = false) => {
    const contentType = 'application/pdf';
    let blobUrl;
    if (isSpsFile === false) {
      const blob = this.b64toBlob(url.replace('data:application/pdf;base64,', ''), contentType);
      blobUrl = URL.createObjectURL(blob);
    } else {
      blobUrl = url;
    }

    this.setState({
      openaddform: true,
      addformtitle: title,
      addNewformComponent: (
        <div style={{ width: '800px', height: '530px', overflow: 'hidden' }}>
          <iframe
            id="iframe"
            onLoad={() => {
              const x = document.getElementById('iframe');
              (((x.contentWindow || {}).document.getElementsByTagName('embed') || [])[0] || {})
                .style.height = '500px';
            }}
            src={blobUrl}
            style={{
              width: '100%',
              height: '100%',
              overflow: 'hidden',
              display: 'block'
            }}
            frameBorder="0"
            allowFullScreen={true}
          ></iframe>
        </div>
      )
    });
  }

  // Get list of uploaded files on Sharepoint for selected PTF
  getUploadedFile = (file, category) => {
    let { filesToBeUploaded } = this.state || [];
    filesToBeUploaded = (filesToBeUploaded || []).filter(x => x.category !== category) || [];
    filesToBeUploaded.push({ category: category, file: file });
    this.setState({ filesToBeUploaded, reloadPtf: !this.state.reloadPtf });
  }

  // Get file data into blob format
  getSpBlob = (url) => {
    return new Promise(function (resolve) {
      fetch(url)
        .then(response => response.blob())
        .then(function (blob) {
          const dataUrl = URL.createObjectURL(blob);
          return resolve(dataUrl);
        }).catch(() => {
          return resolve('');
        }
        );
    });
  }

  // View file data
  viewFileData = async (obj, title) => {
    let url = '';
    if (obj.dbColumn === 'DocumentName') {
      obj.category = 'NewAssignment';
    } else if (obj.dbColumn === 'ChangeOfOwnershipDocumentName') {
      obj.category = 'ChangeInOwnerShip';
    } else if (obj.dbColumn === 'TerminationDocumentName') {
      obj.category = 'Termination';
    }
    if (obj.uploadToSp === true) {
      const { filesToBeUploaded, spsData } = this.state;
      const file = (filesToBeUploaded || []).find(x => x.category === obj.category);
      if (file && file.file) {
        this.getBase64Content(file.file, (result) => {
          url = result;
          this.showFile(url, title);
        });
      } else if (spsData && spsData[obj.category] && spsData[obj.category].length > 0) {
        const spFile = _.orderBy((spsData[obj.category].filter(x => x.name === title) || []), ['createdDateTime'], ['desc']);
        if (spFile && spFile[0]) {
          const url1 = await this.getSpBlob(spFile[0]['@microsoft.graph.downloadUrl']);
          window.open(window.location.origin + '/fileViewer?url=' + url1, '_blank');
        } else {
          ShowToast('File not found!', toastType.INFO, 2000, 2000);
        }
      } else {
        ShowToast('File not found!', toastType.INFO, 2000, 2000);
      }
    } else {
      url = getSectionAttributeValueByKey(this.state.pendingActionsDetails, obj.contentKey);
      this.showFile(url, title);
    }
  };

  // View all files based on selected category
  viewFilesData = async (obj, title, selectedFileName = '') => {
    let url = '';
    if (obj.dbColumn === 'DocumentName') {
      obj.category = 'NewAssignment';
    } else if (obj.dbColumn === 'ChangeOfOwnershipDocumentName') {
      obj.category = 'ChangeInOwnerShip';
    } else if (obj.dbColumn === 'TerminationDocumentName') {
      obj.category = 'Termination';
    }
    if (obj.uploadToSp) {
      const { spsData } = this.state;

      // sharepoint files
      if (spsData && spsData[obj.category] && spsData[obj.category].length > 0) {
        const spFiles = spsData[obj.category] || [];
        if (spFiles && spFiles.length > 0) {
          const selectedFile = spFiles.find(x => x.name === selectedFileName);
          if (selectedFile !== undefined) {
            const url1 = await this.getSpBlob(selectedFile['@microsoft.graph.downloadUrl']);
            window.open(window.location.origin + '/fileViewer?url=' + url1, '_blank');
          } else {
            ShowToast('File not found!', toastType.INFO, 2000, 2000);
          }
        } else {
          ShowToast('File not found!', toastType.INFO, 2000, 2000);
        }
      } else {
        ShowToast('File not found!', toastType.INFO, 2000, 2000);
      }
    } else {
      url = getSectionAttributeValueByKey(this.state.pendingActionsDetails, obj.contentKey);
      this.showFile(url, title);
    }
  };

  // Show Table of client contact details
  getClientContactDetailsUi = (clientContactDetails) => {
    const hiddenConfig = [];

    return (<Paper className="col-xs-12">
      <div className="row">
        <div className="col-xs-12"> <GridTable
          key={'managementFeedetails'}
          columns={UpdateColumnWithConfiguration(
            readOnlyClientContactDetailsColumn,
            [],
            hiddenConfig || []
          )}
          reload={this.state.reloadManagementFeetable}
          config={{ showPager: true, showBottomPagerOnly: true }}
          data={this.getClientContactDetailTabledata(clientContactDetails)}
          renderActionColumn={
            this.renderActionColumn
          }
        ></GridTable>
        </div>
      </div>
    </Paper>);
  }

  // Get Table of Management Fee Details
  getManagementFeeUi = (managementFeeData) => {
    const hiddenConfig = [];
    const applyToAllObj = managementFeeData?.filter(x => _.camelCase(x.dbColumn) === _.camelCase('applyToAll') && x.attributeValue === '1' 
      && x.recordId !== undefined 
      && x.recordId !== '0' 
      && x.recordId !== 'null');
      
    hiddenConfig.push({
      key: 'applyToAll',
      value: getSectionAttributeValueByKey(applyToAllObj, 'applyToAll') === '1'
    });

    return (<Paper className="col-xs-12">
      <div className="row">
        <div className="col-xs-12"> <GridTable
          key={'managementFeedetails'}
          columns={UpdateColumnWithConfiguration(
            readOnlyManagementFeeColumns,
            [],
            hiddenConfig || []
          )}
          reload={this.state.reloadManagementFeetable}
          config={{ showPager: true, showBottomPagerOnly: true }}
          data={this.getManagementFeeTabledata(managementFeeData)}
          renderActionColumn={
            this.renderActionColumn
          }
        ></GridTable>
        </div>
      </div>
    </Paper>);
  }

  // Get Table of Engineer Hour Billing Details
  getEngineerHourBillingUi = (engineerHourBillingData) => {
    const { allowToEdit } = this.state;
    return (<Paper className="col-xs-12">
      <div className="row">
        <div className="col-xs-12">
          <GridTable
            key={'engineerHourBillingDetails'}
            columns={UpdateColumnWithConfiguration(
              allowToEdit ? EngineerHourBillingColumns : EngineerHourBillingColumns.filter(x => x.name !== 'Action'),
              []
            )}
            reload={this.state.reloadEngineerHourBillingTable}
            config={{ showPager: true, showBottomPagerOnly: true }}
            data={this.getEngineerHourBillingTabledata(engineerHourBillingData)}
          ></GridTable>
        </div>
      </div>
    </Paper>);
  }

  // Get Table of Billable Expense Details
  getBillableExpenseUi = (expenseData) => {
    const { allowToEdit } = this.state;
    return (<Paper className="col-xs-12">
      <div className="row">
        <div className="col-xs-12"><GridTable
          key={'billableExpensedetails'}
          columns={UpdateColumnWithConfiguration(
            allowToEdit ? ExpenseColumns : ExpenseColumns.filter(x => x.name !== 'Action'),
            []
          )}
          reload={this.state.reloadBillableExpenseTable}
          config={{ showPager: true, showBottomPagerOnly: true }}
          data={this.getBillableExpenseTabledata(expenseData)}
        ></GridTable>
        </div>
      </div>
    </Paper>
    );
  }

  // Get client contact details to load into table
  getClientContactDetailTabledata(clientContactDetails) {
    const tableData = [];
    const grouped = this.getGroupedData(clientContactDetails);
    (grouped || []).forEach(x => {
      let a = {};
      if (x.recordId !== undefined && x.recordId !== '0' && x.recordId !== 'null') {
        x.data.forEach(y => {
          a = { ...a, ...{ [_.camelCase(y.dbColumn)]: y.attributeValue } };
        });
        tableData.push(a);
      }
    });
    tableData.map(x => {
      x.legalEntity = getSectionAttributeValueByKey(this.state.pendingActionsDetails, 'assignmentName');
      return x;
    });
    return tableData;
  }

  // Get Management Fee details to load into table
  getManagementFeeTabledata(managementFeeData) {
    const tableData = [];
    const grouped = this.getGroupedData(managementFeeData);
    (grouped || []).forEach(x => {
      let a = {};
      if (x.recordId !== undefined && x.recordId !== '0' && x.recordId !== 'null') {
        x.data.forEach(y => {
          a = { ...a, ...{ [_.camelCase(y.dbColumn)]: y.attributeValue } };
        });
        tableData.push(a);
      }
    });
    tableData.map(x => {
      x.legalEntity = getSectionAttributeValueByKey(this.state.pendingActionsDetails, 'assignmentName');
      return x;
    });
    return tableData;
  }

  // Get Engineer Hour Billing details to load into table
  getEngineerHourBillingTabledata(engineerHourBillingData) {
    const tableData = [];
    const grouped = this.getGroupedData(engineerHourBillingData);
    (grouped || []).forEach(x => {
      let a = {};
      if (x.recordId !== undefined && x.recordId !== '0' && x.recordId !== 'null') {
        x.data.forEach(y => {
          a = { ...a, ...{ [_.camelCase(y.dbColumn)]: y.attributeValue } };
        });
        tableData.push(a);
      }
    });
    return tableData;
  }

  // Get Billable Expense table data to load into table
  getBillableExpenseTabledata = (expenseData) => {
    const tableData = [];
    let expenseName = [];
    const grouped = this.getGroupedData(expenseData);
    (grouped || []).forEach(x => {
      let a = {};
      if (x.recordId !== undefined && x.recordId !== '0' && x.recordId !== 'null') {
        a.recordId = x.recordId;
        expenseName = getSectionAttributeValueByKey(x.data, 'ExpenseName')?.split('|');

        x.data.forEach(y => {
          a = { ...a, ...{ [_.camelCase(y.dbColumn)]: y.attributeValue } };
        });
        a.expenseName = expenseName.sort(stringCompare)?.join('|');
        if (a.expenseName && a.expenseName.length > 0) {
          tableData.push(a);
        }
      }
    });

    function stringCompare(a, b) {
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    }

    function compare(a, b) {
      if (a.expensesBillablePropertyName < b.expensesBillablePropertyName) {
        return -1;
      }
      if (a.expensesBillablePropertyName > b.expensesBillablePropertyName) {
        return 1;
      }
      return 0;
    }
    tableData.sort(compare);
    return tableData;
  }

  // Get grouped data of Management Fee based on Record Id
  getGroupedData = (managementFeeData) => {
    return _.chain(managementFeeData || []).groupBy('recordId').map(function (v, i) {
      return {
        recordId: i,
        data: v
      };
    }).value();
  }

  // Select pending Allocation record to view details
  selectAllocation = (e, cellInfo) => {
    let selectedAllocation = this.state.selectedAllocation;
    const headerData = this.state.headerData;
    const data = cloneDeep(this.state.pendingActionsDetails.filter(
      (x) => x.approvalStatus === 'Pending Approval'
    ));
    if (e.target.checked) {
      selectedAllocation.push(cellInfo);
    } else {
      selectedAllocation = selectedAllocation.filter(x => x.allocationId !== cellInfo.allocationId);
    }
    headerData.selectAll = (selectedAllocation || {}).length === (data || {}).length;
    this.setState({ selectedAllocation, headerData, reloadTable: !this.state.reloadTable }, () => { this.forceUpdate(); });
  }

  // Render Action columns on Allocation Table
  renderAllocationActionColumn = (row) => {
    const isChecked = (this.state?.selectedAllocation?.find(x => x.allocationId === row.allocationId) !== undefined || false);
    return (
      <>
        <Tooltip title={isChecked ? 'Deselect Allocation' : 'Select Allocation'}>
          <FormControlLabel
            control={
              <Checkbox
                checked={isChecked}
                onChange={(e) => this.selectAllocation(e, row)}
                name="Select Allocation"
                color="default"
                size="small"
                className={'white-checkbox'}
              />
            }
          />
        </Tooltip>
      </>
    );
  };

  // Filter records
  handleTableHeaderEditChange = (value, fieldName) => {
    const { headerData, pendingActionsDetails } = this.state;
    const selectAllocation = cloneDeep(pendingActionsDetails.filter(
      (x) => x.approvalStatus === 'Pending Approval'
    ));
    headerData[fieldName] = value;

    this.setState({ headerData, selectedAllocation: value ? selectAllocation : [], reload: !this.state.reload }, () => { this.forceUpdate(); });
  }

  // Render components based on conditions
  render() {
    const {
      pendingActionsData,
      openDialog,
      openComment,
      selectedCategory,
      selectedRequestRow,
      uniquCategoryData,
      propertyTypeMasterData,
      serviceTypeMasterData,
      selectedData,
      propertyData
    } = this.state;
    let { pendingActionsDetails } = this.state;

    // Configuration details of fields in the Form
    const DetailsFormConfig = [
      {
        key: 'UpdatedProperties',
        type: controlType.Table,
        columnWidth: 12
      },
      {
        key: 'assignmentName',
        type: controlType.DropDown,
        multiple: false,
        renderAsWhen: {
          key: 'TransitionTypeId',
          value: '1',
          type: controlType.TextBox
        }
      },
      {
        key: 'documentName',
        type: controlType.File,
        contentKey: 'documentContent',
        multiple: false,
        viewFile: true,
        uploadToSp: true,
        category: 'NewAssignment',
        showListOnPopover: true
      },
      {
        key: 'ChangeOfOwnershipDocumentName',
        type: controlType.File,
        contentKey: 'ChangeOfOwnershipDocumentContent',
        multiple: false,
        viewFile: true,
        uploadToSp: true,
        category: 'ChangeInOwnerShip',
        showListOnPopover: true
      },
      {
        key: 'TerminationDocumentName',
        type: controlType.File,
        contentKey: 'TerminationDocumentContent',
        multiple: false,
        viewFile: true,
        uploadToSp: true,
        category: 'Termination',
        showListOnPopover: true
      },
      {
        key: 'W9DocumentName',
        type: controlType.File,
        contentKey: 'W9DocumentContent',
        multiple: false,
        viewFile: true,
        uploadToSp: true,
        category: 'NewAssignment',
        showListOnPopover: true
      },
      // { key: 'propertyType', type: controlType.DropDown, multiple: true, columnWidth: 4 },
      { key: 'propertyType', type: 'Text', multiple: false, columnWidth: 4 },
      { key: 'propertyName', type: 'MultiText', multiple: true, columnWidth: 4 },
      { key: 'serviceType', type: controlType.DropDown, multiple: true, columnWidth: 8 },
      { key: 'emailCC', type: controlType.DropDown, multiple: true, columnWidth: 8, disabled: true },
      { key: 'transitionType', type: controlType.DropDown, multiple: false },
      {
        key: 'marketName',
        type: controlType.DropDown,
        multiple: false
      },
      { key: 'customerName', type: controlType.DropDown, multiple: false },
      { key: 'clientName', type: controlType.DropDown, multiple: false },
      { key: 'newClient', type: controlType.DropDown, multiple: false },
      {
        key: 'assignmentStartDate',
        rules: {
          And: [
            {
              operator: Operators.LessThan,
              key: 'assignmentEndDate'
            }
          ]
        }
      },
      {
        key: 'assignmentEndDate',
        rules: {
          And: [
            {
              operator: Operators.GreaterThan,
              key: 'assignmentStartDate'
            }
          ]
        }
      },
      {
        key: 'ManagementPropertyName',
        type: controlType.DropDown,
        multiple: false,
        columnWidth: 9,
        onChange: this.applyToAll
      },
      {
        key: 'newManagementPropertyName',
        type: controlType.DropDown,
        multiple: false,
        columnWidth: 8,
        onChange: this.applyToAll
      },
      {
        key: 'ApplyToAll',
        type: controlType.Switch,
        multiple: false,
        columnWidth: 3,
        onChange: this.applyToAll
      },
      {
        key: 'emailCC',
        type: controlType.DropDown,
        multiple: true,
        shrink: true
      },
      {
        key: 'Description',
        type: controlType.TextBox,
        shrink: true
      },
      {
        key: 'LegalEntitySF',
        type: controlType.TextBox,
        shrink: true
      },
      {
        key: 'TotalSF',
        type: controlType.TextBox,
        shrink: true
      },
      {
        key: 'CreatedBy',
        type: controlType.TextBox,
        shrink: true
      },
      {
        key: 'ModifiedBy',
        type: controlType.TextBox,
        shrink: true
      },
      {
        key: 'ApprovedBy',
        type: controlType.TextBox,
        shrink: true
      }

    ];

    // Dropdown source's configurations required in the Form
    const dropDownSource = [
      {
        key: 'serviceType',
        option: 'serviceType',
        idField: 'serviceTypeId',
        optionIdField: 'ServiceTypeId',
        source: this.state.serviceTypeMasterData
      },
      {
        key: 'propertyType',
        option: 'propertyTypeName',
        idField: 'propertyTypeId',
        source: this.state.propertyTypeMasterData,
        onChange: this.propertyTypeChange
      },
      {
        key: 'UpdatedProperties',
        option: 'propertyName',
        idField: 'UpdatedPropertiesId',
        optionIdField: 'propertyId',
        source: propertyData,
        onChange: this.CIOPropertyChanges
      },
      {
        key: 'emailCC',
        option: 'email',
        source: this.state.employeesAllMasterData,
        multiple: true
      }
    ];
    let managementFeeData = [];
    let expenseData = [];
    let engineerHourBillingData = [];
    let clientContactDetails = [];
    let oldClientContactDetails = [];
    let newClientContactDetails = [];
    let CIOClients = [];
    let clientContacts = [];
    let CIOPropertydetails = [];
    if (selectedCategory === 'PTF') {
      managementFeeData = getSectionAttributesByKeyValue(pendingActionsDetails, 'sectionId', 37) || [];
      pendingActionsDetails = RemoveSectionAttributeByKeyValue(pendingActionsDetails, 'sectionId', 37) || [];
      engineerHourBillingData = getSectionAttributesByKeyValue(pendingActionsDetails, 'sectionId', 93) || [];
      pendingActionsDetails = RemoveSectionAttributeByKeyValue(pendingActionsDetails, 'sectionId', 93) || [];
      expenseData = getSectionAttributesByKeyValue(pendingActionsDetails, 'sectionId', 49) || [];
      pendingActionsDetails = RemoveSectionAttributeByKeyValue(pendingActionsDetails, 'sectionId', 49) || [];
      clientContactDetails = getSectionAttributesByKeyValue(pendingActionsDetails, 'sectionId', 36) || [];
      clientContacts = cloneDeep(clientContactDetails);
      const uniqueClients = removeDuplicates(clientContacts, 'ContactName');
      console.log(uniqueClients);
      pendingActionsDetails = RemoveSectionAttributeByKeyValue(pendingActionsDetails, 'sectionId', 36) || [];
    }
    if (getSectionAttributeValueByKey(pendingActionsDetails, 'TransitionTypeId')?.toString() === '2') {
      setSectionFieldAttributeByKey(pendingActionsDetails || [], 'UpdatedProperties', 'isVisible', true);
      setSectionFieldAttributeByKey(pendingActionsDetails || [], 'UpdatedProperties', 'isEditable', false);
      setSectionFieldAttributeByKey(pendingActionsDetails || [], 'propertyName', 'isVisible', false);
      setSectionFieldAttributeByKey(pendingActionsDetails || [], 'propertyName', 'isEditable', false);


      const newClientId = getSectionAttributeValueByKey(pendingActionsDetails, 'newClientId');
      const clientId = getSectionAttributeValueByKey(pendingActionsDetails, 'clientId');
      const { propertyMasterData } = this.state;
      const cioPropertyId = getSectionAttributeValueByKey(
        pendingActionsDetails,
        'CiOProperties'
      )?.split('|');
      if (cioPropertyId && cioPropertyId.length > 0) {
        propertyMasterData
          ?.filter((pm) =>
            cioPropertyId.find(
              (ci) => ci?.toString() === pm.propertyId?.toString()
            )
          )
          ?.forEach((prop) => {
            CIOPropertydetails.push(prop);
          });
      }

      let totalSFSum = 0;

      CIOPropertydetails?.filter(x => x.areaSF !== undefined && parseFloat(x.areaSF))?.forEach(x => {
        totalSFSum += parseFloat(x.areaSF);
      });

      if (totalSFSum > 0) {
        setSectionFieldAttributeByKey(pendingActionsDetails || [], 'TotalSF', 'attributeValue', totalSFSum);
      }
      oldClientContactDetails = clientContactDetails.filter(x => x.dbColumn === 'ClientId' && x.attributeValue === clientId)?.map(x => x.recordId);
      newClientContactDetails = clientContactDetails.filter(x => x.dbColumn === 'ClientId' && x.attributeValue === newClientId)?.map(x => x.recordId);
      const clientByRecordId = this.getGroupedData(clientContactDetails.filter(x => x.recordId != '0'));
      CIOClients = clientByRecordId.filter(y => newClientContactDetails?.find(z => z === y.recordId))?.map(x => x.data)?.flat();
      clientContacts = clientByRecordId.filter(y => oldClientContactDetails?.find(z => z === y.recordId))?.map(x => x.data)?.flat();
    } else {
      setSectionFieldAttributeByKey(pendingActionsDetails || [], 'UpdatedProperties', 'isVisible', false);
      setSectionFieldAttributeByKey(pendingActionsDetails || [], 'UpdatedProperties', 'isEditable', false);
      setSectionFieldAttributeByKey(pendingActionsDetails || [], 'propertyName', 'isVisible', true);
      setSectionFieldAttributeByKey(pendingActionsDetails || [], 'propertyName', 'isEditable', false);
      let totalSFSum = 0;

      propertyData?.filter(x => x.areaSF !== undefined && parseFloat(x.areaSF))?.forEach(x => {
        totalSFSum += parseFloat(x.areaSF);
      });

      if (totalSFSum > 0) {
        setSectionFieldAttributeByKey(pendingActionsDetails || [], 'TotalSF', 'attributeValue', totalSFSum);
      }
    }
    const transitionSeparatorConfig = [
      {
        separatorBeforeKey: 'ClientName',
        label:
          (this.state.selectedTransitionTypeId || '1').toString() === '2'
            ? 'Current Assignment Details'
            : 'Assignment Details',
        order: 1,
        row: 1,
        sectionColumn: 4
      },
      {
        separatorBeforeKey: 'NewClient',
        label: 'New Ownership Details',
        order: 2,
        row: 1,
        sectionColumn: 4
      },
      {
        separatorBeforeKey: 'ManagementPropertyName',
        label: 'Management Fee',
        order: 1,
        row: 2,
        sectionColumn: 10
      },
      {
        separatorBeforeKey: 'NewFeePercentage',
        label: 'New Ownership Management Fee',
        order: 2,
        row: 2,
        sectionColumn: 10
      }
    ];
    return (
      <>
        <div className="row">
          <div className="col-sm-12">
            <PageHeader
              key={'Pending_Request_List'}
              title={'Pending Request List'}
            // actionsConfig={[
            //   {
            //     icon: (
            //       <NavLink
            //         to={{
            //           pathname: '/Dashboard'
            //           //  navProps: {
            //           //    selectedRow: value
            //           //  }
            //         }}
            //         style={{ color: '#FFF', fontSize: 'small' }}>
            //         <ArrowBackIcon
            //           size="small"
            //           className="back-button no-print"
            //           style={{ cursor: 'pointer' }}
            //         />
            //       </NavLink>
            //     ),
            //     // onClick: this.goBack,
            //     title: 'Back to Dashboard'
            //   }
            // ]}
            >
              Pending Request List
            </PageHeader>
            <PageFilter
              autoFilter={false}
              filterAlwaysVisible={this.props.renderAsChild !== true}
              onFilterChanged={this.onFilterChange}
              hidePanel={true}
              filterConfig={[
                {
                  multiple: true,
                  type: controlType.DropDown,
                  source: uniquCategoryData,
                  key: 'category',
                  placeholder: 'Category',
                  title: 'Category',
                  isComaSeprated: true
                },
                // {
                //   multiple: true,
                //   type: controlType.DropDown,
                //   source: uniqueDescriptionData,
                //   key: 'categoryDescription',
                //   title: 'Description',
                //   // operator: Operators.In
                //   isComaSeprated: true
                // },
                {
                  type: controlType.DatePicker,
                  key: 'modifiedOn',
                  placeholder: 'Modified On',
                  title: 'Modified On'
                  // operator: Operators.GreaterThanEqualsTo
                }
              ]}
              gridColumn={3}
              defaultSelectedData={[]}
              selectedData={selectedData}
            ></PageFilter>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12">
            {pendingActionsData === null
              ? (
                <>{'No Requests Available'}</>
              )
              : (
                <>
                  <GridTable
                    columns={UpdateColumnWithConfiguration(
                      PedingActionColumns,
                      this.state.configuration || []
                    )}
                    config={{ showPager: true }}
                    data={pendingActionsData}
                    renderActionColumn={this.renderActionColumn}
                  ></GridTable>
                </>
              )}{' '}
          </div>
        </div>

        <Dialog
          onClose={this.handleClose}
          aria-labelledby="customized-dialog-title"
          maxWidth={'lg'}
          open={openDialog}
        >
          <div className="row">
            <div className="col-sm-6">
              {' '}
              <DialogTitle
                id="customized-dialog-title"
                onClose={() => {
                  this.setState({ openDialog: false });
                }}
              >
                Pending Review
              </DialogTitle>
            </div>
            <div className="col-sm-6" style={{ textAlign: 'right' }}>
              <IconButton
                aria-label="close"
                onClick={() => {
                  const headerData = this.state.headerData;
                  headerData.selectAll = false;
                  this.setState({
                    openDialog: false,
                    pendingActionsDetails: [],
                    pendingActionsDetailsConfig: [],
                    openComment: false,
                    selectedCategory: undefined,
                    selectedRequestRow: undefined,
                    selectedAllocation: [],
                    headerData
                  });
                }}
              >
                <CloseIcon />
              </IconButton>
            </div>
          </div>

          <DialogContent dividers>
            <Paper>
              <div className="row">
                <div className="col-sm-12">
                  {selectedRequestRow !== undefined
                    ? (
                      <table className="table-details-pending">
                        <tr>
                          <td colSpan={2}>
                            Category: {selectedRequestRow.category}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Updated By:&nbsp; {selectedRequestRow.modifiedBy}
                          </td>
                          <td>
                            Modified On:&nbsp;{' '}
                            {moment(selectedRequestRow.modifiedOn).format(
                              'MM/DD/YYYY'
                            )}
                          </td>
                        </tr>
                      </table>
                    )
                    : null}
                </div>
              </div>
              {selectedCategory === 'Market Allocation' ||
                selectedCategory === 'Property Allocation'
                ? (
                  <>
                    <div className="row">
                      <PageHeader
                        key={'Pending_Allocation_List'}
                        title={'Pending ' + selectedCategory + ' List'}
                      >
                        Pending Request List
                      </PageHeader>
                    </div>
                    <GridTable
                      columns={UpdateColumnWithConfiguration(
                        selectedCategory === 'Market Allocation'
                          ? PendingMarketAllocation
                          : PendingPropertyAllocation,
                        this.state.configuration || []
                      )}
                      reload={this.state.reloadTable}
                      config={{ showPager: true }}
                      data={pendingActionsDetails.filter(
                        (x) => x.approvalId === 3
                      )}
                      headerData={this.state.headerData}
                      renderActionColumn={this.renderAllocationActionColumn}
                      handleTableHeaderEditChange={this.handleTableHeaderEditChange}
                      swapBadge={{
                        key: 'parentSwapAllocationId',
                        notEqualsTo: 0,
                        referenceKey: 'allocationId',
                        class: 'message rotate-badge',
                        title: 'Auto Swap',
                        tooltip: 'This is the record created for swapping of employee ',
                        separateBySpace: true
                      }}
                    ></GridTable>
                    <div className="row" style={{ marginTop: '32px' }}>
                      <PageHeader
                        key={'Allocation List'}
                        title={'Current ' + selectedCategory + ' List'}
                      ></PageHeader>
                    </div>
                    <GridTable
                      columns={UpdateColumnWithConfiguration(
                        selectedCategory === 'Market Allocation'
                          ? PendingMarketAllocation.filter(x => x.name !== '')
                          : PendingPropertyAllocation.filter(x => x.name !== ''),
                        this.state.configuration || []
                      )}
                      config={{ showPager: true }}
                      data={pendingActionsDetails.filter(
                        (x) => x.approvalId !== 3 && x.allocationId > 0
                      )}
                      renderActionColumn={this.renderAllocationActionColumn}
                    ></GridTable>

                  </>
                )
                : (
                  <>
                    <FormGenerator
                      key={'addnewproperty'}
                      gridColumn={4}
                      formFields={UpdateFieldsWithConfiguration(
                        pendingActionsDetails,
                        DetailsFormConfig,
                        []
                      )}
                      dropDownSource={dropDownSource}
                      validationMessages={[]}
                      // saveChanges={this.SaveNewProperty}
                      partialForm={false}
                      Editable={false}
                      viewPDF={this.viewFilesData}
                      getUploadedFile={this.getUploadedFile}
                      separatorConfig={transitionSeparatorConfig}
                      sectionColumn={4}
                      sectionRowConfig={[
                        { row: 1, column: 8 },
                        { row: 2, column: 4 }
                      ]}
                    >
                    </FormGenerator>
                    {selectedCategory === 'PTF' &&
                      <>
                        <div className="col-sm-12 start-sm innerHeader">
                          <PageHeader
                            key={'clientContactDetails'}
                            title="Client Contact Details"
                          ></PageHeader>
                          <div className="col-sm-12 end-sm">
                            <hr className="hr-custom" />
                          </div>
                        </div>

                        <div className="row">
                          {this.getClientContactDetailsUi(clientContacts)}
                        </div>

                        {CIOClients.length > 0 && <><div className="col-sm-12 start-sm innerHeader">
                          <PageHeader
                            key={'clientContactDetails'}
                            title="New Client Contact Details"
                          >

                          </PageHeader>
                          <div className="col-sm-12 end-sm">
                            <hr className="hr-custom" />
                          </div>

                        </div>

                          <div className="row">
                            {this.getClientContactDetailsUi(CIOClients)}
                          </div></>}

                        {/* Management Fee Table */}
                        <div className="col-sm-12 start-sm innerHeader">
                          <PageHeader
                            key={'ManagementFee'}
                            title="Management Fee(s)"
                          >
                          </PageHeader>
                          <div className="col-sm-12 end-sm">
                            <hr className="hr-custom" />
                          </div>
                        </div>
                        <div className="row">
                          {this.getManagementFeeUi(managementFeeData)}
                        </div>

                        {/* Billable Expense Table */}
                        <div className="col-sm-12 start-sm innerHeader">

                          <PageHeader
                            key={'expenseFee'}
                            title="Billable Expense(s)"
                          >

                          </PageHeader>
                          <div className="col-sm-12 end-sm">
                            <hr className="hr-custom" />
                          </div>
                        </div>
                        <div className="row">
                          {this.getBillableExpenseUi(expenseData)}
                        </div>

                        {/* Engineer Hour Billing Table*/}
                        <div className="col-sm-12 start-sm innerHeader">
                          <PageHeader key={'EngineerHourBilling'} title="Engineer Hour Billing"></PageHeader>
                          <div className="col-sm-12 end-sm">
                            <hr className="hr-custom" />
                          </div>
                        </div>
                        <div className="row">
                          {this.getEngineerHourBillingUi(engineerHourBillingData)}
                        </div>

                        {/* Property Details Table */}
                        <div className="col-sm-12 start-sm innerHeader">
                          <PageHeader key={'Property_Details'} title=" Property Details">
                            {' '}
                            Property Details
                          </PageHeader>
                          <div className="col-sm-12 end-sm">
                            <hr className="hr-custom" />
                          </div>
                        </div>
                        <div className="row">
                          <GridTable
                            key={'propertyDetails'}
                            columns={UpdateColumnWithConfiguration(
                              propertyColumnsPTF.filter(x => x.name !== 'Action')
                            )}
                            config={{ showPager: true, showBottomPagerOnly: true }}
                            data={this.state.propertyData}
                            renderActionColumn={
                              () => {
                                return <></>;
                              }
                            }
                          ></GridTable>
                        </div>

                        {/* CIO Properies details table */}
                        {CIOPropertydetails.length > 0 && <>
                          <div className="col-sm-12 start-sm innerHeader">
                            <PageHeader key={'Property_Details'} title=" CIO Property Details">
                              {' '}
                              CIO Property Details
                            </PageHeader>
                            <div className="col-sm-12 end-sm">
                              <hr className="hr-custom" />
                            </div>
                          </div>
                          <div className="row">
                            <GridTable
                              key={'propertyDetails'}
                              columns={UpdateColumnWithConfiguration(
                                propertyColumnsPTF.filter(x => x.name !== 'Action')
                              )}
                              config={{ showPager: true, showBottomPagerOnly: true }}
                              data={CIOPropertydetails}
                              renderActionColumn={
                                () => {
                                  return <></>;
                                }
                              }
                            ></GridTable>
                          </div></>}

                        {/* Employee Allocation Table */}
                        <div className="col-sm-12 start-sm innerHeader">
                          <PageHeader key={'Employee_Allocation'} title=" Employee Allocation">
                            {' '}
                            Employee Allocation
                          </PageHeader>
                          <div className="col-sm-12 end-sm">
                            <hr className="hr-custom" />
                          </div>
                        </div>
                        <div className="row">
                          <GridTable
                            key={'allocationTable'}
                            columns={UpdateColumnWithConfiguration(
                              PendingPropertyAllocation.filter(x => x.name !== ''),
                              this.state.allocationConfiguration || []
                            )}
                            config={{ showPager: true, showBottomPagerOnly: true }}
                            data={(this.state.allocationData || []).filter(x => x.allocationId > 0)}
                            renderActionColumn={
                              () => {
                                return <></>;
                              }
                            }
                          ></GridTable>
                        </div>
                      </>
                    }
                  </>
                )}
              {openComment && <div className="row bottomSpace">&nbsp;</div>}
            </Paper>
            {openComment
              ? (
                <div className="row bottomSpace alwaysVisible">
                  <div className="col-xs-12">
                    <TextareaAutosize
                      aria-label="Enter Your Comments"
                      className="pending-request-text-box"
                      rowsMin={4}
                      onChange={(e) => {
                        this.setState({ reviewComment: e.target.value });
                      }}
                      placeholder="Enter Your Comments"
                    />
                  </div>
                </div>
              )
              : null}
          </DialogContent>
          <DialogActions>
            {' '}
            &nbsp;
            {openComment
              ? (
                <>
                  <Button
                    autoFocus
                    onClick={() => {
                      this.approveRequest();
                    }}
                    color="primary"
                    disabled={this.state.isSaveButtonDisabled}
                  >
                    Save changes
                  </Button>
                  <Button
                    autoFocus
                    onClick={() => {
                      this.setState({ openComment: false, reviewComment: '' });
                    }}
                    color="primary"
                  >
                    Cancel
                  </Button>
                </>
              )
              : (
                IsSectionVisible(SECTIONS.PENDING_ACTION, 0, SECTIONS.ADD_EDIT) && <> <Button
                  onClick={() => {
                    if (
                      this.state.selectedRequestRow.category === 'Market Allocation' ||
                      this.state.selectedRequestRow.category === 'Property Allocation'
                    ) {
                      if (this.state.selectedAllocation === undefined || this.state.selectedAllocation.length <= 0) {
                        ShowToast(
                          'Please select at least one pending ' + this.state.selectedRequestRow.category + '.',
                          toastType.ERROR,
                          5000,
                          commonLabels.somethingWrong.code
                        );
                        return false;
                      }
                    }
                    this.setState({ openComment: true, approve: true });
                  }}
                  color="primary"
                >
                  Approve
                </Button>
                  <Button
                    autoFocus
                    onClick={() => {
                      if (
                        this.state.selectedRequestRow.category === 'Market Allocation' ||
                        this.state.selectedRequestRow.category === 'Property Allocation'
                      ) {
                        if (this.state.selectedAllocation === undefined || this.state.selectedAllocation.length <= 0) {
                          ShowToast(
                            'Please select at least one pending ' + this.state.selectedRequestRow.category + '.',
                            toastType.ERROR,
                            5000,
                            commonLabels.somethingWrong.code
                          );
                          return false;
                        }
                      }
                      this.setState({ openComment: true, approve: false });
                    }}
                    color="primary"
                  >
                    Decline/Suggest changes
                  </Button>
                </>
              )}
          </DialogActions>

        </Dialog>
        {this.state.viewFile && (
          <Dialog open={this.state.viewFile} maxWidth="lg">
            <AppBar
              style={{ position: 'relative', backgroundColor: '#064473' }}
            >
              <Toolbar>
                <Typography
                  variant="h6"
                  className="app-header-white"
                  style={{ marginLeft: '10px', flex: '1', color: '#FFFFF' }}
                >
                  {this.state.addformtitle}
                </Typography>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={() => {
                    this.setState({
                      viewFile: false,
                      addNewformComponent: undefined
                    });
                  }}
                  aria-label="close"
                >
                  <IoMdCloseCircleOutline />
                </IconButton>
              </Toolbar>
            </AppBar>
            <div>
              <Paper>{this.state.addNewformComponent}</Paper>
            </div>
          </Dialog>
        )}
      </>
    );
  }
}

export default PendingRequests;
